import { render, staticRenderFns } from "./joinHands.vue?vue&type=template&id=6625a3ad&scoped=true&"
import script from "./joinHands.vue?vue&type=script&lang=js&"
export * from "./joinHands.vue?vue&type=script&lang=js&"
import style0 from "./joinHands.vue?vue&type=style&index=0&id=6625a3ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625a3ad",
  null
  
)

export default component.exports